<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <!-- MainView -->
      <article @click.self="open = false" :class="{ 'full-column' : !open }" class="wrapper wrapper-content main-column">
        <!-- ViewTitleBox -->
        <div class="ibox-tools view-title">
          <h1 class="info-menu view-name">
            <img src="static/img/assets/nav_okr_on.png" alt="">
            <span v-if="this.$route.params.item">{{$t('okrEditType')}}</span>
            <span v-else>{{$t('okrRegisType')}}</span>
          </h1>
          <div class="wrapper" v-if="isProxy">
            <span class="info-userimg">
              <img v-if="getUserInfoById(uid).userIcon" class="img-circle" :src="getUserInfoById(uid).userIcon"  :alt='getUserInfoById(uid).userName'>
              <img v-else class="img-circle" :src="'static/img/noImage.png'"  :alt='getUserInfoById(uid).userName'>
            </span>
            <span class="info-username">{{ getUserInfoById(uid).userName }}</span>
            <span>{{ getUserInfoById(uid).dept }}</span>
          </div>
          <span class="info-right">
          </span>
          </div>
          <div v-if="isLiteMode">
            <b-alert variant="danger" show>{{$t('liteIsStr')}}</b-alert>
          </div>
          <div v-else>
          <!-- /ViewTitleBox -->
            <section class="animated fadeInRight">
              <div class="ibox">
                <form @submit.prevent class="ibox-content" action="okr/list">
                  <div class="ibox-child">
                    <div class="row">
                      <div class="form-group col-sm-12">
                        <label class="control-label">{{$t('okrDetailType')}}</label>
                        <textarea class="form-control" :placeholder="$t('inputOkrGoalStr')" rows="7" v-model="objectiveInfo.contentText" required=""></textarea>
                        <span v-if="!$v.objectiveInfo.contentText.contentTextValidation" class="text-danger font-bold">{{$t('alertRequiredItemStr')}}</span>
                      </div>
                    </div>
                  </div>
                  <regist-limit :view="view" :dueDate="this.dueDate" :startDate="this.startDate" :progress="getRate" :alertDate="this.$v.dueDate.dueDateValidation" v-on:set-progress="updateProgressInfo"/>
                  <regist-Share @delete-share-user="deleteShareUser" @reset-share="resetSelectShare" @open-share="setDetail" :checkedUsers="this.checkedShareUsers" />
                  <regist-public @delete-public-user="deletePublicUser" @delete-public-group="deletePublicGroup" @delete-public-org="deletePublicOrg" @reset-public="resetSelectPublic" @open-public="setDetail" :checkedUsers="this.checkedPublicUsers" :checkedGroups="this.checkedPublicGroups" :checkedOrgs="this.checkedPublicOrgs"/>
                  <regist-relation @openRelation="setDetail" :checkedObjectives="this.checkedObjectives" v-on:delete-relation="deleteRelation"/>
                  <div class="ibox-child">
                    <div class="row okr-regist-btnset" v-if="isProxy">
                      <div class="col-lg-6 col-md-6 col-sm-6"><button @click="newObjective" type="button" class="btn btn-success block m-b" :disabled="checkRegistering">{{$t('saveStr')}}</button></div>
                      <div class="col-lg-6 col-md-6 col-sm-6"><button @click="onClickCancel" type="button" class="btn btn-danger block m-b">{{ $t('cancelStr') }}</button></div>
                    </div>
                    <div class="row okr-regist-btnset" v-else>
                      <div class="col-lg-4 col-md-4 col-sm-4"><button @click="newObjective" type="button" class="btn btn-success block m-b" :disabled="checkRegistering">{{$t('saveStr')}}</button></div>
                      <div class="col-lg-4 col-md-4 col-sm-4"><button @click="cancelObjectives" type="button" class="btn btn-primary block m-b" :disabled="checkRegistering">{{$t('popTitleStr2Type')}}</button></div>
                      <div class="col-lg-4 col-md-4 col-sm-4"><button @click="onClickCancel" type="button" class="btn btn-danger block m-b">{{ $t('cancelStr') }}</button></div>
                    </div>
                  </div>
                </form>
              </div>
            </section>
        </div>
      </article>

      <!-- DetailView -->
      <div id="detailView" class="sub-column" :class="{ 'sub-active' : open }">
        <div class="close-content"><div @click="open = false" class="close-btn cursor"><i class="fa fa-angle-right"></i></div></div>
        <article class="sub-content-wrap">
          <section class="inner-wrap">
            <div class="s-inner-wrap">
              <div class="ibox-title flex-box fl-between ibox-detail-header">
                <span class="info-menu flex-box">
                  <template v-if="detail == 'public'">{{$t('publicSettingLabelTitle')}}</template>
                  <template v-if="detail == 'relation'">{{$t('relatedOkrType')}}</template>
                  <template v-if="detail == 'share'">{{$t('shareSettingLabelTitle')}}</template>
                </span>
                <span class="info-right"></span>
              </div>
            <!-- Public -->
            <public-setting-detail-view v-if="detail == 'public'"
              :checkedOrgs="checkedPublicOrgs"
              :checkedGroups="checkedPublicGroups"
              :checkedUsers="checkedPublicUsers"
              :uid="uid"
              @updateGroups="onClickPublicGroups"
              @updateOrganization="onClickPublicOrg"
              @updateUsers="onClickPublicUsers"
              ref="publicSetting"/>
              <share-setting-detail-view v-if="detail == 'share'"
              :checkedUsers="checkedShareUsers"
              :uid="uid"
              @updateUsers="onClickShareUsers"
              ref="shareSetting"/>
          <!-- /Public  -->

            <!-- RelationObject -->
            <div v-else-if="detail == 'relation'" class="ibox">
                <div class="ib-sub-content">
                    <!-- ユーザー検索ボックス -->
                    <div class="ibox-title search-box">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="input-group">
                                    <input type="text" v-model="searchText" class="typeahead_2 form-control" :placeholder="$t('searchWithUserName')">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ibox-content search-resultview">
                        <ul v-if="searchText == ''">
                            <li v-if="getVisitedUsers.length === 0"><label>{{$t('notFoundUserStr')}}</label></li>
                            <li><label>{{$t('checkUserStrType')}}</label></li>
                              <div v-for="user in getVisitedUsers" :key="user.id" v-if="user && user.userInfo">
                                <li @click="onClickUser(user.userId, user)">
                                  <span class="search-userimg">
                                    <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                                    <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                                  </span>
                                  <div class="search-userinfo">
                                    <span class="search-username">{{ user.userInfo.userName }}</span>
                                    <span class="search-userdept">{{ user.userInfo.dept }}</span>
                                  </div>
                                  <span class="check-mark"></span>
                              </li>
                            </div>
                        </ul>
                        <ul v-else>
                          <li v-if="Object.keys(this.getUsersBySearchText).length === 0"><label>{{$t('notFoundUserStr')}}</label></li>
                          <div v-for="(user, key) in getUsersBySearchText" :key="user.id" v-if="user && user.userInfo">
                            <li @click="onClickUser(key, user)">
                                <span class="search-userimg">
                                  <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                                  <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                                </span>
                                <div class="search-userinfo">
                                  <span class="search-username">{{ user.userInfo.userName }}</span>
                                  <span class="search-userdept">{{ user.userInfo.dept }}</span>
                                </div>
                            </li>
                          </div>
                          </ul>
                          <div>
                            <transition name="fade">
                              <div v-if="showModal" class="modal-mask">
                                <div class="modal-wrapper">
                                  <div class="modal-container">
                                    <div class="modal-header">
                                      <slot name="header">
                                        <span class="search-userimg">
                                          <img v-if="targetUser.userInfo.userIcon" :src="targetUser.userInfo.userIcon" alt="image" class="img-circle">
                                          <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                                        </span>
                                        <div class="search-userinfo">
                                          <span class="search-username">{{ this.targetUser.userInfo.userName }}</span>
                                          <span class="search-userdept">{{ this.targetUser.userInfo.dept }}</span>
                                        </div>
                                      </slot>
                                    </div>
                                    <div class="modal-body">
                                      <div class="m-body-wrap">
                                        <slot name="body">
                                          <div v-for="(item, index) in getRelationObjectives" v-if="checkRelationsFillter(item.obj, item.key)" :key="index" :class="{'comp-mark' : getIsComp(item.obj)}" class="ibox">
                                            <div :class="{'added' : !isShowObjectives(item.key)}" class="ibox-title">
                                              <label>
                                                <input v-if="isShowObjectives(item.key)" type="checkbox" v-model="preCheckedObjs" :value="{userId: targetUserId, targetId: item.key, type: 'objectives'}" class="checkbox relation-check">
                                                <span class="check-mark"></span>
                                                <objective :addMore="true" :detailView="false" :content="item.obj.contentText" :itemId="item.key" :progress="item.obj.progress ? item.obj.progress : '0'" :setReadOnly="'false'"  :objective="false" />
                                                <span class="due-date due-date-color">{{$t('dueDateStr')}} : {{item.obj.dueDate}}</span>
                                                <div class="ibox-tools">
                                                  <span @click.stop.prevent="setKeyresultOpen(item.key)" class="info-menu cursor">
                                                    <button class="btn btn-secondary">
                                                      <i :class="{'chevronUp' : !getIsOpen(item.key)}" class="fa fa-chevron-down"></i>
                                                      <span v-if="!getIsOpen(item.key)">{{$t('indicateItemClose')}}</span>
                                                      <span v-else>{{$t('indicateAllNotice')}}</span>
                                                    </button>
                                                  </span>
                                                  <span class="info-right">
                                                    <span class="info-comment-detail">
                                                      <img src="static/img/assets/comment.png">
                                                      <span>{{getCommentsByItemId(item.key, targetType).length}}</span>
                                                  </span>
                                                    <span class="info-comment-detail">{{$t('createDateString')}} : {{item.obj.createdAt | preparedTime}}</span>
                                                  </span>
                                                </div>
                                              </label>
                                            </div>
                                          <div :class="{'keyResultClose' : getIsOpen(item.key)}" class="ibox-content key-indent">
                                            <!-- ボックス -->
                                            <!-- KeyResult1 -->
                                            <div v-for="(keyresult, keyresultId) in getTargetKeyresults(item.key)" :key="keyresultId" v-if="keyresult.contentText && !keyresult.isComplete" class="ibox-child cursor" :class="{'comp-mark' : getIsComp(keyresult), 'added' : !isShowObjectives(keyresultId)}">
                                              <div><label>
                                                <input type="checkbox" v-model="preCheckedObjs" :value="{userId: targetUserId, targetId: keyresultId, type: 'keyresults'}" class="checkbox relation-check">
                                                <span class="check-mark"></span>
                                                <div>
                                                  <span class="comp"></span>
                                                  <objective :content="keyresult.contentText" :progress="keyresult.progress ? keyresult.progress : '0'" :setReadOnly="'false'"  :objective="false" />
                                                </div>
                                                <span class="due-date due-date-color">{{$t('dueDateStr')}} : {{keyresult.dueDate}}</span>
                                                <div class="ibox-tools">
                                                  <span class="info-menu"></span>
                                                  <span class="info-right">
                                                    <span class="info-comment-detail">
                                                      <img src="static/img/assets/comment.png"><span>{{getCommentsByItemId(keyresultId,'keyresults').length}}</span>
                                                    </span>
                                                    <span class="info-comment-detail">{{$t('createDateString')}} : {{keyresult.createdAt|  preparedTime}}</span>
                                                  </span>
                                                </div>
                                              </label></div>
                                            </div>
                                            <!-- /KeyResult1  -->
                                            <!-- /ボックス -->
                                          </div>
                                        </div>
                                        </slot>
                                      </div>
                                    </div>
                                    <div class="modal-footer">
                                      <slot name="footer">
                                        <div class="row okr-regist-btnset">
                                          <div class="col-lg-4 col-md-4 col-sm-4 col-sm-offset-2"><button @click="onClickModalOk" type="button" class="modal-default-button btn btn-success">{{ $t('modalOkStr') }}</button></div>
                                          <div class="col-lg-4 col-md-4 col-sm-4"><button @click="closeModal" type="button" class="modal-default-button btn btn-danger">{{ $t('cancelStr') }}</button></div>
                                        </div>
                                      </slot>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </transition>

                          </div>
                    </div>
                    <!-- /ユーザー検索ボックス -->
                </div>
            </div>
            <!-- /RelationObject  -->
            </div>
          </section>
        </article>
      </div>

    </div>
  </div>

</template>

<script>
import Vue from 'vue'
import RegistLimit from '@/components/Regist/RegistLimit'
import RegistPublic from '@/components/Regist/RegistPublic'
import RegistRelation from '@/components/Regist/RegistRelation'
import RegistShare from '@/components/Regist/RegistShare'
import Objective from '@/components/Okr/Objective'
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import { liteMode } from '@/main.js'
import OrganizationItem from '@/components/People/OrganizationItem'
import PublicSettingDetailView from '@/components/DetailView/PublicSettingDetailView'
import ShareSettingDetailView from '@/components/DetailView/ShareSettingDetailView'
function contentTextValidation () {
  return this.objectiveInfo.contentText.trim().replace(/\r?\n/g, '').length !== 0
}

function dueDateValidation () {
  return this.dueDate ? this.dueDate >= this.startDate : true
}

export default {
  name: 'ObjectiveRegist',
  mixedins: [validationMixin],
  components: {
    RegistLimit,
    RegistPublic,
    RegistRelation,
    Objective,
    OrganizationItem,
    PublicSettingDetailView,
    ShareSettingDetailView,
    RegistShare
  },
  data: function () {
    return {
      isLiteMode: liteMode,
      tag: 'regist',
      view: 'Okr',
      open: false,
      detail: '',
      showModal: false,
      keyresultOpen: {},
      targetType: 'objectives',
      dueDate: new Date(),
      startDate: new Date(),
      progress: '0',
      searchText: '',
      groups: {},
      targetUserId: '',
      targetUser: {},
      checkedPublicGroups: [],
      checkedPublicUsers: [],
      checkedPublicOrgs: [],
      checkedShareUsers: [],
      preCheckedObjs: [],
      checkedObjectives: [],
      oldRelationInfos: [],
      progressMax: 100,
      progressMin: 0,
      objectiveInfo: {
        contentText: '',
        dueDate: '',
        progress: '0',
        keyresults: {},
        limitedAccess: {},
        relations: {},
        startDate: '',
        createdAt: new Date()
      },
      id: this.$route.params.id,
      isProxy: this.$route.params.isProxy,
      proxyUserId: this.$route.params.proxyUserId,
      checkDraft: false,
      isRegistering: false
    }
  },
  validations: {
    objectiveInfo: {
      contentText: {
        contentTextValidation,
        required
      }
    },
    dueDate: {
      dueDateValidation
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'ObjectiveRegist'
    },
    checkRegistering () {
      return this.isRegistering
    },
    ...mapGetters([
      'getUserId',
      'getCurrentUser',
      'getCurrentUserInfo'
    ]),
    ...mapGetters('okrs/', [
      'getRelationInfo'
    ]),
    ...mapGetters('keyResults/', [
      'getKeyresultsByParentObjId'
    ]),
    ...mapGetters('objectives/', [
      'getObjectivesByUserId',
      'getCurrentDraftObjectives'
    ]),
    ...mapGetters('comments/', [
      'getCommentsByItemId'
    ]),
    ...mapGetters('groups/', [
      'getCurrentGroupsByText',
      'getOnlyGroupsBySearchText',
      'getGroupsByIds',
      'getCurrentGroups',
      'getGroups'
    ]),
    ...mapGetters('users/', [
      'getUsersByText',
      'getUsersByIds',
      'getUsers',
      'getUserInfoById'
    ]),
    ...mapGetters('organizations/', [
      'getOnlyOrganizationsByText',
      'getOpenOrganization',
      'getOrganizationExpansion',
      'getOrganizationRoots',
      'getOnlyOrganizationsByIds'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsDeleted'
    ]),
    getVisitedUsers: function () {
      const currentUser = this.getCurrentUser
      console.log('currentUser', currentUser)
      if (currentUser && currentUser.hasOwnProperty('visitHistory')) {
        console.log('in if getVisit')
        // return this.getUsersByIds(Object.keys(currentUser.visitHistory))
        const visitHistory = Object.keys(currentUser.visitHistory || [])
        const recentlyCheckedUsers = this.getUsersByIds(Object.keys(currentUser.visitHistory))
        let sortedRecentlyCheckedUsers = visitHistory.sort((a, b) => { return currentUser.visitHistory[b] - currentUser.visitHistory[a] })
          .filter(key => !this.getMetaIsDeleted(key))
          .map(x => { return recentlyCheckedUsers[x] })
        console.log(sortedRecentlyCheckedUsers)
        return sortedRecentlyCheckedUsers
      } else {
        console.log('in else getVisit')
        return {}
      }
    },
    getGroupsBySearchText: function () {
      return this.getOnlyGroupsBySearchText(this.searchText)
    },
    getUsersBySearchText: function () {
      if (this.searchText.length === 0) {
        this.usersForRelation = this.getUsers
        return this.getUsers
      } else {
        this.usersForRelation = this.getUsersByText(this.searchText)
        return this.getUsersByText(this.searchText)
      }
    },
    // getObjForModal () {
    //   let checkedObjTargetIds = {}
    //   let targetUserObjs = this.getObjectivesByUserId(this.targetUserId)
    //   if (this.checkedObjectives[0]) {
    //     for (let cobj in this.checkedObjectives) {
    //       checkedObjTargetIds.targetId = this.checkedObjectives[cobj].targetId
    //       console.log(Object.values(checkedObjTargetIds))
    //     }
    //     for (let objkey in targetUserObjs) {
    //       if (Object.values(checkedObjTargetIds).filter(x => x === objkey).length > 0) {
    //         delete targetUserObjs[objkey]
    //       }
    //     }
    //   }
    //   return targetUserObjs
    // },
    getRate: {
      get: function () {
        return this.progress ? this.progress : '0'
      },
      set: function (value) {
        this.progress = String(value)
      }
    },
    getRelationObjectives: function () {
      let relationOkrs = []
      if (this.targetUserId) {
        const relationOkrObj = this.getObjectivesByUserId(this.targetUserId)
        for (let key in relationOkrObj) {
          if (key === '.key') { continue }
          if (relationOkrObj[key] && relationOkrObj[key].contentText !== '') {
            if (!relationOkrObj[key].isComplete) {
              relationOkrs.push({key: key, obj: relationOkrObj[key]})
            } else if (relationOkrObj[key].isComplete === false) {
              relationOkrs.push({key: key, obj: relationOkrObj[key]})
            } else {
              continue
            }
          }
        }
        return relationOkrs.reverse()
      } else {
        return relationOkrs
      }
    },
    getOrganizationsBySearchText: function () {
      if (this.searchText.length === 0) {
        return this.getGroups
      } else {
        return this.getOnlyOrganizationsByText(this.searchText)
      }
    },
    uid: function () {
      return this.proxyUserId || this.getUserId
    }
  },
  beforeMount: function () {
    this.groups = this.getGroups
    if (this.$route.params.item) {
      const dueDate = new Date(this.$route.params.item.dueDate)
      this.dueDate = dueDate
      if (this.$route.params.item.startDate) {
        const startDate = new Date(this.$route.params.item.startDate)
        this.startDate = startDate
      } else {
        this.startDate = null
      }
      if (this.$route.params.item.progress) {
        this.getRate = this.$route.params.item.progress
      } else {
        this.getRate = 0
      }
    }
  },
  mounted: function () {
    if (this.isRegistering) {
      this.isRegistering = false
    }
    if (this.$route.params.item) {
      this.objectiveInfo.contentText = this.$route.params.item.contentText
      this.objectiveInfo.createdAt = this.$route.params.item.createdAt
      console.log(this.$route.params.item.progress)

      // this.getRate = this.$route.params.item.progress
      if (this.$route.params.item.limitedAccess) {
        if (this.$route.params.item.limitedAccess.limitedUsers) {
          this.checkedPublicUsers = Object.keys(this.$route.params.item.limitedAccess.limitedUsers)
        }
        if (this.$route.params.item.limitedAccess.limitedGroups) {
          let allGroups = this.getGroupsByIds(Object.keys(this.$route.params.item.limitedAccess.limitedGroups))
          let groupIds = Object.keys(allGroups).filter(x => !allGroups[x].isOrganization)
          let orgIds = Object.keys(allGroups).filter(x => allGroups[x].isOrganization)
          this.checkedPublicGroups = groupIds
          this.checkedPublicOrgs = orgIds
        }
      }
      if (this.$route.params.item.sharedOwners) {
        this.checkedShareUsers = Object.keys(this.$route.params.item.sharedOwners).filter(userId => userId !== this.uid)
      }
      if (this.$route.params.item.keyresults) {
        this.objectiveInfo.keyresults = this.$route.params.item.keyresults
      }
      console.log(this.$route.params.item)
      if (this.$route.params.item.relations) {
        this.checkedObjectives = Object.values(this.$route.params.item.relations).map(x => ({
          userId: x.userId,
          targetId: x.key,
          type: x.type
        }))
        console.log(this.checkedObjectives)
        this.oldRelationInfos = this.$route.params.item.relations
      }
    } else if (!this.isProxy && Object.keys(this.getCurrentDraftObjectives).filter(x => !this.getCurrentDraftObjectives[x] ? false : this.getCurrentDraftObjectives[x].contentText).length > 0) {
      this.$swal({
        title: this.$t('comfirmMakeFromDraftStr'),
        type: 'question',
        showCancelButton: true,
        reverseButtons: false,
        cancelButtonColor: '#f64846',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        allowOutsideClick: false,
        padding: '2rem'
        // timer: 5000
      }).then((result) => {
        if (result.value) {
          this.checkDraft = true
          const CDObjective = this.getCurrentDraftObjectives
          console.log(CDObjective)
          for (let x of Object.keys(CDObjective)) {
            if (CDObjective[x].contentText) {
              console.log('true', CDObjective[x])
              this.objectiveInfo.contentText = CDObjective[x].contentText
              this.getRate = CDObjective[x].progress
              this.dueDate = new Date(CDObjective[x].dueDate)
              if (CDObjective[x].limitedAccess) {
                if (CDObjective[x].limitedAccess.limitedUsers) {
                  this.checkedPublicUsers = Object.keys(CDObjective[x].limitedAccess.limitedUsers)
                }
                if (CDObjective[x].limitedAccess.limitedGroups) {
                  this.checkedPublicGroups = Object.keys(CDObjective[x].limitedAccess.limitedGroups)
                } else if (CDObjective[x].limitedAccess.limitedGroup) {
                  this.checkedPublicGroups = Object.keys(CDObjective[x].limitedAccess.limitedGroup)
                }
              }
              if (CDObjective[x].sharedOwners) {
                this.checkedShareUsers = Object.keys(CDObjective[x].sharedOwners).filter(userId => userId !== this.uid)
              }
              if (CDObjective[x].startDate) {
                this.startDate = new Date(CDObjective[x].startDate)
              }
              if (CDObjective[x].relations) {
                this.checkedObjectives = Object.values(CDObjective[x].relations).map(x => ({userId: x.userId, targetId: x.key, type: x.type}))
              }
            }
          }
        } else {
          console.log('false')
        }
      })
    }
  },
  methods: {
    ...mapActions('peoples', {
      setVisit: 'SET_VISIT_HISTORY'
    }),
    ...mapActions('objectives/', {
      setnewRelation: 'SET_NEW_OBJECTIVE_RELATION',
      removeDraftsObjectives: 'REMOVE_DRAFTS_OBJECTIVES',
      setDraftsObjectives: 'SET_DRAFTS_OBJECTIVES',
      setNewObjective: 'SET_NEW_OBJECTIVE'
    }),
    onClickModalOk () {
      this.showModal = false
      this.checkedObjectives = this.checkedObjectives.concat(this.preCheckedObjs)
      this.preCheckedObjs = []
      console.log(this.checkedObjectives)
    },
    isShowObjectives: function (objectiveId) {
      let checkedObjTargetIds = {}
      console.log('isShowObjectives', objectiveId)
      if (this.checkedObjectives.length !== 0) {
        for (let cobj in this.checkedObjectives) {
          checkedObjTargetIds.targetId = this.checkedObjectives[cobj].targetId
          console.log(checkedObjTargetIds.targetId)
          if (objectiveId === checkedObjTargetIds.targetId) {
            console.log('isShowObjectives: false')
            return false
          } else {
            console.log('isShowObjectives: true')
          }
        }
        return true
      } else {
        return true
      }
    },
    onClickPublicGroups: function (value) {
      this.checkedPublicGroups = value
    },
    onClickPublicOrg: function (value) {
      this.checkedPublicOrgs = value
    },
    onClickPublicUsers: function (value) {
      this.checkedPublicUsers = value
    },
    onClickShareUsers: function (value) {
      this.checkedShareUsers = value
    },
    onClickUser: function (key, user) {
      let objectives = this.getObjectivesByUserId(key)
      let count
      let $t = this.$t
      // console.log('getOnClickUserOkrs::', this.getObjectivesByUserId(key))
      if (Object.keys(objectives).length === 0) {
        this.$swal({
          title: $t('popTitleStrType'),
          text: $t('noObjective'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      } else {
        count = Object.keys(objectives).length
        for (let id in objectives) {
          if (objectives[id].isComplete) {
            count = count - 1
          }
        }
        if (count > 0) {
          this.targetUserId = key
          this.targetUser = user
          this.showModal = true
        } else {
          this.$swal({
            title: $t('popTitleStrType'),
            text: $t('noObjective'),
            type: 'warning',
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            padding: '2rem',
            timer: 3000
          })
        }
      }
    },
    closeModal () {
      this.showModal = false
    },
    resetSelectPublic: function () {
      this.checkedPublicUsers = []
      this.checkedPublicGroups = []
      this.checkedPublicOrgs = []
      this.$refs.publicSetting.resetCheckings()
    },
    resetSelectShare: function () {
      this.checkedShareUsers = []
      this.$refs.shareSetting.resetCheckings()
    },
    deletePublicUser: function (userId) {
      let targetIndex = this.checkedPublicUsers.indexOf(userId)
      this.checkedPublicUsers.splice(targetIndex, 1)
    },
    deletePublicGroup: function (groupId) {
      let targetIndex = this.checkedPublicGroups.indexOf(groupId)
      this.checkedPublicGroups.splice(targetIndex, 1)
    },
    deletePublicOrg: function (orgId) {
      let targetIndex = this.checkedPublicOrgs.indexOf(orgId)
      this.checkedPublicOrgs.splice(targetIndex, 1)
    },
    deleteShareUser: function (userId) {
      let targetIndex = this.checkedShareUsers.indexOf(userId)
      this.checkedShareUsers.splice(targetIndex, 1)
    },
    setDetail (value) {
      // console.log('parent methods clear')
      this.detail = value
      this.open = true
    },
    getIsOpen: function (objectiveId) {
      return Object.keys(this.keyresultOpen).filter(x => x === objectiveId).length === 0 ? false : this.keyresultOpen[objectiveId]
    },
    setKeyresultOpen: function (objectiveId) {
      Vue.set(this.keyresultOpen, objectiveId, Object.keys(this.keyresultOpen).filter(x => x === objectiveId).length === 0 ? true : !this.keyresultOpen[objectiveId])
    },
    getTargetKeyresults (key) {
      // 算出プロパティだと引数がつけられないためmethodに
      return this.getKeyresultsByParentObjId(key)
    },
    getIsComp: function (item) {
      return Object.keys(item).filter(x => x === 'isComplete').length === 0 ? false : item.isComplete
    },
    updateProgressInfo: function (value) {
      // console.log('updateProgressInfo', value)
      // this.progress = value
      // this.getRate = value

      this.getRate = value
    },
    getObjectives () {
      console.log(this.checkedPublicGroups)
    },
    newObjective: function () {
      console.log('objectiveInfo', this.$v.objectiveInfo)
      if (!this.$v.objectiveInfo.contentText.contentTextValidation) {
        this.$swal({
          title: this.$t('setupObjectiveGoal'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      } else if (!this.$v.dueDate.dueDateValidation) {
        this.$swal({
          title: this.$t('alertDateStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      } else if (!this.dueDate || !this.startDate) {
        this.$swal({
          title: this.$t('noDayStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      } else {
        var ddt = this.dueDate
        var dstr = ddt.getFullYear() + '/' +
        ('0' + (ddt.getMonth() + 1)).slice(-2) + '/' +
        ('0' + ddt.getDate()).slice(-2)
        this.objectiveInfo.dueDate = dstr
        if (this.startDate) {
          var sdt = this.startDate
          var sstr = sdt.getFullYear() + '/' +
          ('0' + (sdt.getMonth() + 1)).slice(-2) + '/' +
          ('0' + sdt.getDate()).slice(-2)
          this.objectiveInfo.startDate = sstr
        }
        this.isRegistering = true
        const objectiveId = this.id
        let removeDraft = this.removeDraftsObjectives
        // this.objectiveInfo.dueDate = this.dueDate
        // console.log(Date.parse(str))
        if (this.progress) {
          this.objectiveInfo.progress = String(Math.min(this.progressMax, Math.max(this.progressMin, this.progress)))
        } else {
          this.objectiveInfo.progress = '0'
        }
        this.objectiveInfo.createdAt = this.$route.params.id ? this.objectiveInfo.createdAt : new Date().getTime() / 1000
        this.objectiveInfo.modifiedAt = new Date().getTime() / 1000
        if (this.checkedPublicUsers.length > 0) {
          this.objectiveInfo.limitedAccess.limitedUsers = this.parseArrayToObject(this.checkedPublicUsers)
        } else {
          this.objectiveInfo.limitedAccess.limitedUsers = null
        }
        if (this.checkedPublicGroups.length > 0 || this.checkedPublicOrgs.length > 0) {
          let Groups = this.checkedPublicGroups
          if (this.checkedPublicOrgs.length > 0) {
            Groups = Groups.concat(this.checkedPublicOrgs)
          }
          this.objectiveInfo.limitedAccess.limitedGroups = this.parseArrayToObject(Groups)
        } else {
          this.objectiveInfo.limitedAccess.limitedGroups = null
        }
        if (this.checkedShareUsers.length > 0) {
          this.checkedShareUsers.push(this.uid)
          this.objectiveInfo.sharedOwners = this.parseArrayToObject(this.checkedShareUsers)
        }
        let existingKeys = Object.values(this.oldRelationInfos).map(x => x.key)
        const value = {
          'objectiveInfo': this.objectiveInfo,
          'relationInfo': this.getRelationInfo(this.checkedObjectives.filter(x => !existingKeys.includes(x.targetId)), this.getUsersByIds(this.checkedObjectives.map(x => x['userId'])))
        }
        this.objectiveInfo.relations = {}
        for (let key in this.oldRelationInfos) {
          if (this.checkedObjectives.map(x => x.targetId).filter(x => x === this.oldRelationInfos[key].key).length > 0) {
            value.objectiveInfo.relations[key] = this.oldRelationInfos[key]
          }
        }
        console.log('value.objectiveInfo:::', value.objectiveInfo)
        let data = {
          // data.okrに関連情報を値渡しする
          okr: JSON.parse(JSON.stringify(value.objectiveInfo)),
          userId: this.getUserId
        }
        for (let i in value.relationInfo) {
          data.okr.relations[i] = value.relationInfo[i]
        }
        const validateRelationOKR = this.$firebase.functions().httpsCallable('validateRelationOKR')
        validateRelationOKR(data)
          .then(result => {
            console.log('validate relations result:::', result)
            const $t = this.$t
            if (result.data.status) {
              const warnText = result.data.text.split('\n').join('<br>')
              // エラーになったよ
              this.$swal({
                title: $t('popTitleStrType'),
                html: warnText,
                type: 'warning',
                animation: false,
                customClass: 'animated fadeInUp',
                // customClass: 'animated flipInX',
                width: '50vh',
                position: 'center',
                padding: '2rem'
              }).then((result) => {
                this.isRegistering = false
                if (result.value) {
                  // OK押したよ
                  return { result: false }
                } else {
                  // OKおしてないよ
                  return { result: false }
                }
              })
            } else {
              // 登録できるよ
              return { result: true }
            }
          })
          .then(swalResult => {
            if (swalResult) {
              console.log('set relation', value.relationInfo)
              if (this.isProxy) {
                const proxyOKRinLieuOfUser = this.$firebase.functions().httpsCallable('proxyOKRinLieuOfUser')
                const proxyValue = {
                  'targetUserId': this.uid,
                  'targetItemType': 'objectives',
                  'targetItemId': '',
                  'targetValue': value
                }
                if (!objectiveId) {
                  proxyOKRinLieuOfUser(proxyValue).then(() => {
                    this.$router.push({ name: 'ProxyOkr', params: {targetUser: this.uid} })
                  })
                } else {
                  proxyValue.targetItemId = objectiveId
                  proxyOKRinLieuOfUser(proxyValue).then(() => {
                    this.$router.push({ name: 'ProxyOkr', params: {targetUser: this.uid} })
                  })
                }
              } else {
                if (!objectiveId) {
                  this.setNewObjective(value)
                  if (this.checkDraft) {
                    removeDraft(this.getUserId)
                    this.checkDraft = false
                  }
                  console.log('new objective created!')
                } else {
                  value.objectiveId = objectiveId
                  this.setNewObjective(value)
                }

                /* add relation and limited users to visited user list start */
                for (let checkedObjective of this.checkedObjectives) {
                  this.setVisit(checkedObjective.userId)
                }
                /* add relation and limited users to visited user list end */
                this.$router.push('/okr/list')
              }
            }
          })
      }
    },
    cancelObjectives: function () {
      const $t = this.$t
      if (!this.$v.objectiveInfo.contentText.contentTextValidation) {
        this.$swal({
          title: this.$t('setupObjectiveGoal'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      } else if (!this.$v.dueDate.dueDateValidation) {
        this.$swal({
          title: this.$t('alertDateStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      } else {
        var ddt = this.dueDate
        var dstr = ddt.getFullYear() + '/' +
        ('0' + (ddt.getMonth() + 1)).slice(-2) + '/' +
        ('0' + ddt.getDate()).slice(-2)
        this.objectiveInfo.dueDate = dstr
        if (this.startDate) {
          var sdt = this.startDate
          var sstr = sdt.getFullYear() + '/' +
          ('0' + (sdt.getMonth() + 1)).slice(-2) + '/' +
          ('0' + sdt.getDate()).slice(-2)
          this.objectiveInfo.startDate = sstr
        }
        this.objectiveInfo.progress = this.progress
        this.objectiveInfo.createdAt = new Date().getTime() / 1000
        if (this.checkedPublicUsers.length > 0) {
          this.objectiveInfo.limitedAccess.limitedUsers = this.parseArrayToObject(this.checkedPublicUsers)
        }
        if (this.checkedShareUsers.length > 0) {
          this.objectiveInfo.shareUsers = this.parseArrayToObject(this.checkedShareUsers)
        }
        if (this.checkedPublicGroups.length > 0) {
          this.objectiveInfo.limitedAccess.limitedGroups = this.parseArrayToObject(this.checkedPublicGroups)
        }
        const value = {
          'objectiveInfo': this.objectiveInfo,
          'relationInfo': this.getRelationInfo(this.checkedObjectives, this.getUsersByIds(this.checkedObjectives.map(x => x['userId'])))
        }
        if (Object.keys(this.getCurrentDraftObjectives).filter(x => !this.getCurrentDraftObjectives[x] ? false : this.getCurrentDraftObjectives[x].contentText).length > 0) {
          this.$swal({
            title: $t('popTitleStrType'),
            text: $t('popMessageStr2Type'),
            showCancelButton: true,
            cancelButtonColor: '#f64846',
            type: 'warning',
            confirmButtonClass: 'btn btn-success',
            cancelButtonClass: 'btn btn-danger',
            reverseButtons: false,
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            allowOutsideClick: false,
            padding: '2rem'
            // timer: 5000
          }).then((result) => {
            if (result.value) {
              console.log('true')
              this.setDraftsObjectives(value)
              this.$swal({
                title: this.$t('compStorageStr'),
                type: 'success',
                animation: false,
                customClass: 'animated fadeInUp',
                // customClass: 'animated flipInX',
                width: '35rem',
                position: 'center',
                // toast: true,
                padding: '2rem',
                timer: 3000
              })
              if (this.isProxy) {
                this.$router.push({ name: 'ProxyOkr', params: {targetUser: this.uid} })
              } else {
                this.$router.push('/okr/list')
              }
            } else {
              console.log('false')
              this.$router.push('/okr/objective-regist')
            }
          })
        } else {
          this.$swal({
            title: this.$t('compStorageStr'),
            type: 'success',
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            padding: '2rem',
            timer: 3000
          })
          this.setDraftsObjectives(value)
          if (this.isProxy) {
            this.$router.push({ name: 'ProxyOkr', params: {targetUser: this.uid} })
          } else {
            this.$router.push('/okr/list')
          }
        }
      }
    },
    deleteRelation: function (id, type) {
      this.checkedObjectives = this.checkedObjectives.filter(x => !(x.type === type && x.targetId === id))
    },
    parseArrayToObject: function (array) {
      let obj = {}
      for (const i in array) {
        obj[array[i]] = 1
      }
      return obj
    },
    onClickCancel: function () {
      const $t = this.$t
      this.$swal({
        title: $t('popTitleStrType'),
        text: $t('confirmInputDeleteStr'),
        showCancelButton: true,
        cancelButtonColor: '#f64846',
        type: 'warning',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        reverseButtons: false,
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        allowOutsideClick: false,
        padding: '2rem'
        // timer: 5000
      }).then((result) => {
        if (result.value) {
          if (this.isProxy) {
            this.$router.push({ name: 'ProxyOkr', params: {targetUser: this.uid} })
          } else {
            this.$router.push('/okr/list')
          }
        } else {
          console.log('false')
        }
      })
    },
    checkRelationsFillter: function (obj, objectiveId) {
      if (this.$route.params.item && this.$route.params.id) {
        if (obj.contentText && !obj.isComplete && this.$route.params.id !== objectiveId) return true
        else return false
      } else {
        if (obj.contentText && !obj.isComplete) return true
        else return false
      }
    }
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal {
  position: absolute;
  top: 10%;
  display: block;
  width: 80%;
  height: auto;
  margin: 0 auto;
  opacity: 1.0;
  overflow: visible;
}
.modal-wrapper{
  height: 100vh;
  display: table-cell;
  vertical-align: middle;
}
.key-indent .ibox-child {
    transition: all 0.2s ease-in-out;
    height: 180px;
  }
  /* .ibox-child.add-key { height: 80px; } */
  .keyResultClose .ibox-child {
    height: 0;
    margin: 0 auto;
    padding-top: 0;
    padding-bottom: 0;
    overflow:  hidden;
    border: none;
  }
  .fa-chevron-down{
    transition: all 0.2s ease-in-out;
  }
  .chevronUp{
    transform: rotate(180deg);
  }
  .added:after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    background-color: #445;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.4;
}
</style>



// WEBPACK FOOTER //
// src/views/okr/ObjectiveRegist.vue